import { render, staticRenderFns } from "./regionBudget.vue?vue&type=template&id=589704dd&scoped=true"
import script from "./regionBudget.vue?vue&type=script&lang=js"
export * from "./regionBudget.vue?vue&type=script&lang=js"
import style0 from "./regionBudget.vue?vue&type=style&index=0&id=589704dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589704dd",
  null
  
)

export default component.exports